import { transportProgressFactory } from '@rtls/core/models/transports/transport-progress.factory';
import {
	random,
	randomDate,
	randomName,
	randomNumber,
	randomSentence,
	randomSizeList,
	randomWord,
} from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts';
import { journeyFactory } from './journey.factory';
import { participantFactory } from './participant.factory';
import { Transport } from './transport.model';

export const transportFactory = Factory.makeFactory<Transport>({
	cancellationReason: Factory.each(() => randomSentence()),
	cancelled: Factory.each(() => random()),
	deletedDate: Factory.each(() => new Date(randomDate())),
	extId: Factory.each(() => randomWord()),
	journey: Factory.each(() => journeyFactory.build()),
	name: Factory.each(() => randomWord()),
	participants: Factory.each(() =>
		randomSizeList(
			() => participantFactory.build(),
			30,
			() => random(30),
		),
	),
	provider: Factory.each(() => randomName()),
	startDate: Factory.each(() => new Date(randomDate()).toISOString().slice(0, 10)),
	uuid: Factory.each(() => randomWord()),
	progress: Factory.each(() => transportProgressFactory.build()),
});
